<template>
  <div class="cig-breadcrumb">
    <div
      :class="['breadcrumb-title', showBack ? 'breadcrumb-back' : 'title-mode']"
    >
      <el-icon v-show="showBack" :size="bigSize">
        <icon-circle-arrow-left />
      </el-icon>
      <p :style="{ fontSize: bigSize }">{{ title }}</p>
    </div>
    <el-breadcrumb class="breadcrumb" v-bind="option" :style="{ fontSize }">
      <template v-for="(item, index) in data" :key="index">
        <el-breadcrumb-item class="breadcrumb-item" v-bind="item">
          <el-icon v-if="item.icon" class="breadcrumb-icon" :size="item.size">
            <component :is="item.icon" />
          </el-icon>
          {{ item.title }}
        </el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { ElBreadcrumb, ElBreadcrumbItem } from '@park-ui/components/breadcrumb'
import ElIcon from '@park-ui/components/icon'
import { IconCircleArrowLeft } from '@park-ui/components/cig-icon'
import defaultProps from './breadcrumb/defaults'

export default defineComponent({
  name: 'ElCigBreadcrumb',
  components: {
    ElBreadcrumb,
    ElBreadcrumbItem,
    ElIcon,
    IconCircleArrowLeft,
  },
  props: defaultProps,
  emits: ['jump'],
  setup(props, { emit }) {
    // init here
    const click = (item: any) => {
      emit('jump', item)
    }
    const defaultColor = ref('#909399')
    const activeColor = ref('#0fccdb')
    const title = computed(() => {
      const title = props.data[props.data.length - 1].title
      return title
    })
    const fontSize = computed(() => {
      const unit = typeof props.size === 'string' ? '' : 'px'
      return props.size + unit
    })
    return {
      title,
      defaultColor,
      activeColor,
      fontSize,
      click,
    }
  },
})
</script>
